import cookies from 'js-cookie';
import { dataLayer, fbq } from '../globals';

export enum Acceptance {
    YES = 'true',
    NO = 'false',
}

export class Gdpr {

    public static ACCEPT_COOKIE_KEY = 'acl_cookies_accepted';

    private passed?: boolean;

    private confirmed?: boolean;

    public get alreadyAccepted(): boolean {
        if (typeof this.passed === 'undefined') {
            this.passed = Object.values(Acceptance).includes(cookies.get(Gdpr.ACCEPT_COOKIE_KEY) || '');
        }

        return this.passed;
    }

    public get accepted(): boolean {
        if (!this.alreadyAccepted) {
            return false;
        }
        if (typeof this.confirmed === 'undefined') {
            this.confirmed = cookies.get(Gdpr.ACCEPT_COOKIE_KEY) === Acceptance.YES;
        }

        return this.confirmed;
    }

    constructor() {
        this.grant();
        // Flush old cookies
        // Todo remove in 2021, all of this cookies should be expired
        ['acl_notification_redesign', 'cookies_accepted'].forEach((c) => {
            cookies.remove(c, { path: '/' });
        });
    }

    public accept(reason: Acceptance) {
        // Emit only one time
        if (this.alreadyAccepted) {
            return;
        }
        this.passed = true;
        this.confirmed = reason === Acceptance.YES;
        cookies.set(Gdpr.ACCEPT_COOKIE_KEY, reason, { path: '/', expires: 365 });
        this.grant();
        dataLayer.push({
            eventAction: this.confirmed ? 'Accepted' : 'Declined',
            eventCategory: 'Cookie',
            event: 'cookie:accept',
        });
    }

    private grant() {
        if (!this.accepted) {
            return;
        }
        // Maybe rise this event to load some tags in GTM?
        // dataLayer.push({ event: 'cookieAccepted' });
        // Add grants for fqb works only after full initialization
        const i = setInterval(() => {
            if (!('instance' in (fbq as any))) {
                return;
            }
            fbq('consent', 'grant');
            clearInterval(i);
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/gdpr.ts